import './App.css';
import "./styles/font_style.css"

import { Route, Routes } from 'react-router-dom';
import Divorce from './pages/divorce/Divorce';
import Detective from "./pages/detective/Detective";
import Compensation from "./pages/compensation/Compensation";
import Accusation from "./pages/accusation/Accusation";

import { useEffect, useState } from "react";
import Main from "./pages/Main";

export const useTitle = initialTitle => {
  const [title, setTitle] = useState(initialTitle);

  useEffect(() => {
      const htmlTitle = document.querySelector("title");
      htmlTitle.innerHTML = title;
  }, [title])

  return setTitle;
}

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/divorce" element={<Divorce />} />
        <Route path="/detective" element={<Detective />} />
          <Route path="/compensation" element={<Compensation />} />
          <Route path="/accusation" element={<Accusation />} />
      </Routes>
    </>
  );
}

export default App;
